import React, { useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { authenticateWithTelegram } from '../store/slices/userSlice';
import { ROUTES } from '../constants';
import { TelegramLoginButton } from '../components/TelegramLoginButton';
import type { TelegramUser } from '@wbstats/shared';
import { Typography, Spin, Space, Card } from 'antd';

const { Title, Text, Paragraph } = Typography;

// Type for location state
interface LocationState {
  from?: string;
}

export const Login = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { isLoading, error } = useAppSelector((state) => state.user);
  const locationState = location.state as LocationState;
  const from = locationState?.from || ROUTES.HOME;
  const useMockButton = window.location.protocol === 'http:';

  const handleAuth = useCallback(
    (user: TelegramUser) => {
      void dispatch(authenticateWithTelegram(user)).then(() => {
        navigate(from);
      });
    },
    [dispatch, navigate, from]
  );

  // Add this effect to check URL parameters
  useEffect(() => {
    // Check if we have Telegram auth data in URL
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get('id');
    const first_name = queryParams.get('first_name');
    const username = queryParams.get('username');
    const auth_date = queryParams.get('auth_date');
    const hash = queryParams.get('hash');

    // If we have Telegram data in URL parameters
    if (id && first_name && auth_date && hash) {
      console.log('Found Telegram auth data in URL');

      // Construct user object from URL parameters
      const user = {
        id: parseInt(id),
        first_name,
        username: username || undefined,
        auth_date: parseInt(auth_date),
        hash,
        is_bot: false,
      } as TelegramUser;

      // Handle the authentication
      handleAuth(user);

      // Clear URL parameters to prevent re-authentication on refresh
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }, [handleAuth]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'calc(100vh - 48px)',
      }}
    >
      <Card style={{ width: '100%', maxWidth: '400px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
        <Space direction="vertical" align="center" style={{ width: '100%' }}>
          <Title level={2} style={{ textAlign: 'center', margin: '0 0 8px' }}>
            Вход в WBStats
          </Title>

          <Paragraph style={{ textAlign: 'center', marginBottom: '24px' }}>
            Пожалуйста, войдите в WBStats с помощью своей учетной записи Telegram
          </Paragraph>

          {isLoading ? (
            <Spin size="large" />
          ) : (
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '16px' }}>
              <TelegramLoginButton
                botName="user_tracking_bot"
                onAuth={handleAuth}
                useMock={useMockButton}
              />
            </div>
          )}

          {error && (
            <Text type="danger" style={{ textAlign: 'center' }}>
              {error}
            </Text>
          )}
        </Space>
      </Card>
    </div>
  );
};
